import axiosClient from "./axiosClient";

const refreshToken = () => {
  const url = "/users/refresh";
  return axiosClient.post(url);
};

const getUserToken = () => {
  const url = "/users/index";
  return axiosClient.get(url);
};

const deleteUserByEmail = (params) => {
  const url = "/users/deleteUserByEmail";
  return axiosClient.delete(url, params);
};

const deleteUsersByEmail = (payload) => {
  const url = "/users/deleteUsersByEmail";
  const { contactParams, emails, excludedEmails, isDeleteAll, alertId } = payload;
  delete contactParams.page;
  delete contactParams.limit;
  return axiosClient.delete(url, {
    data: {
      emails: Array.isArray(emails) ? emails : [emails],
      excludedEmails: Array.isArray(excludedEmails) ? excludedEmails : [excludedEmails],
      isDeleteAll,
      contactParams,
      alertId,
    },
  });
};

const sendResetPasswordRequestV2 = (params) => {
  const url = "/users/forgotPassword/v2";
  return axiosClient.post(url, params);
};

const confirmResetPasswordV2 = (params) => {
  const url = "/users/forgotPassword/v2/submit";
  return axiosClient.post(url, params);
};

const validateRecoverPasswordLink = (code, email) => {
  const url = `/users/forgotPassword/v2/validate?code=${encodeURIComponent(
    code
  )}&email=${encodeURIComponent(email)}`;
  return axiosClient.get(url);
};

const sendReset2FARequest = (params) => {
  const url = "/users/reset2fa";
  return axiosClient.post(url, params);
};

const validateReset2FALink = (code, email) => {
  const url = `/users/reset2fa/validate?code=${encodeURIComponent(
    code
  )}&email=${encodeURIComponent(email)}`;
  return axiosClient.get(url);
};

const confirmReset2FA = (params) => {
  const url = "/users/reset2fa/confirm";
  return axiosClient.post(url, params);
};

const updateContact = (params) => {
  const url = "/users/updateContact";
  return axiosClient.post(url, params);
};

const getNameByReferral = (referralPath, referralCode) => {
  const url = `/referral/${referralPath}/${referralCode}`;
  return axiosClient.get(url);
};

const changeReferralURL = (referralPath, referralCode) => {
  const url = `/referral/${referralCode}`;
  return axiosClient.get(url, referralPath);
};

const logoutApi = () => {
  const url = "users/logout";
  return axiosClient.post(url);
};

const preLoginApi = (params) => {
  const url = "/users/preLogin";
  return axiosClient.post(url, params);
};

const connectUserApi = () => {
  const url = "/users/connect";
  return axiosClient.post(url);
};

const reconnectUserApi = () => {
  const url = "/users/reconnect";
  return axiosClient.post(url);
};

const createUserApi = (params) => {
  const url = "/users/register";
  return axiosClient.post(url, params);
};

const getUserInfo = () => {
  const url = "/users/me";
  return axiosClient.get(url);
};

const updateUserInfo = (params) => {
  const url = `/users/me`;
  return axiosClient.put(url, params);
};

const generateSMSVerification = (id, email) => {
  const url = `/users/generateSMSVerification/${id}/${email}`;
  return axiosClient.get(url);
};
const validateEmail = (id) => {
  const url = `/users/validate/email/${id}`;
  return axiosClient.get(url);
};

const validateEmailPasswordResetRequired = (email) => {
  const url = `/users/validate/email/${email}/password-reset-required`;
  return axiosClient.get(url);
};

const validatePhoneNumber = (id) => {
  const url = `/users/validate/phoneNumber/${id}`;
  return axiosClient.get(url);
};

const resendSMSVerification = (phoneNumber, email) => {
  const url = `/users/regenerateSMSVerification/${phoneNumber}/${email}`;
  return axiosClient.get(url);
};

const verifyPhoneNumber = (codeId, id, email) => {
  const url = `/users/verifyPhoneNumber/${codeId}/${id}/${email}`;
  return axiosClient.get(url);
};

const getUserCounters = () => {
  const url = `/users/counters`;
  return axiosClient.get(url);
};

export {
  changeReferralURL,
  confirmReset2FA,
  deleteUserByEmail,
  deleteUsersByEmail,
  resendSMSVerification,
  updateContact,
  refreshToken,
  getUserToken,
  getNameByReferral,
  logoutApi,
  verifyPhoneNumber,
  validateEmail,
  validatePhoneNumber,
  generateSMSVerification,
  updateUserInfo,
  getUserInfo,
  preLoginApi,
  connectUserApi,
  createUserApi,
  reconnectUserApi,
  confirmResetPasswordV2,
  sendReset2FARequest,
  sendResetPasswordRequestV2,
  validateEmailPasswordResetRequired,
  validateRecoverPasswordLink,
  validateReset2FALink,
  getUserCounters,
};
